<template>
  <el-table :data="data" style="width: 100%;" :row-class-name="tableRowClassName" height="calc(100% - 90px)">
    <el-table-column label="序号" type="index" width="50">
    </el-table-column>
    <el-table-column label="客户代码" width="200" prop="UserCode">
      <!-- <template slot-scope="scope">
        <el-button @click="goUserInfo(scope.row)" type="text">{{scope.row.UserCode}}</el-button>
      </template> -->
    </el-table-column>
    <el-table-column  label="客户名称" width="230" prop="UserName">
    </el-table-column>
    <!-- <el-table-column label="手续费模板ID" width="250">
      <template slot-scope="scope">
        <el-button @click="gomTemplateInfo(scope.row)" type="text">{{scope.row.FeeTemplateID}}</el-button>
      </template>
    </el-table-column> -->
    <el-table-column label="手续费模板" width="250" prop="FeeTemplateName">
    </el-table-column>
    <el-table-column prop="Phone" label="手机号码" width="150">
      <template slot-scope="scope">
        <span>{{scope.row.Phone == null ? "--" : (scope.row.Phone == "" ? "--" : scope.row.Phone)}}</span>
      </template>
    </el-table-column>
    <el-table-column prop="CreateDate" label="开户时间">
    </el-table-column>
    <el-table-column label="来源">
      <template slot-scope="scope">
        {{scope.row.Source | GetSource}}
      </template>
    </el-table-column>
    <el-table-column label="操作">
      <template slot-scope="scope">
        <!-- <el-button @click="handleClick(scope.row.UserCode)" type="text" size="small">客户详情</el-button> -->
         <el-dropdown trigger="click">
              <span class="el-dropdown-link">
                <el-button class="el-icon-caret-bottom el-icon--right opera_btn" type="primary" size="mini"></el-button>
              </span>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item class="clearfix" @click.native="handleClick(scope.row.UserCode)">
                  客户详情
                  <el-badge class="mark">
                  </el-badge>
                </el-dropdown-item>
                <el-dropdown-item class="clearfix"  v-if="AgentFeeTemplatesIsShow" @click.native="editClick(scope.row)">
                  编辑
                  <el-badge class="mark">
                  </el-badge>
                </el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
      </template>
    </el-table-column>
    <!-- 查看明细弹窗 -->
      <el-dialog title="客户详情" :visible.sync="dialogVisible" append-to-body width="60%">
          <div class="infobox clearfix">
              <div class="infoboxinfo">
                  <span>手续费模板名称:</span>
                  <input type="text" v-model="obj.FeeTemplateName"  disabled>
              </div>
              <div class="infoboxinfo">
                  <span>保证金模板名称:</span>
                  <input type="text" v-model="obj.MarginTemplateName" disabled>
              </div>
               <div class="infoboxinfo">
                  <span>风控模板名称:</span>
                  <input type="text" v-model="obj.RiskTemplateName" disabled>
              </div>
          </div>
          <span slot="footer" class="dialog-footer">
            <el-button @click="dialogVisible = false">取 消</el-button>
            <el-button type="primary" @click="dialogVisible = false">确 定</el-button>
          </span>
        </el-dialog>
         <!-- 查看明细弹窗 -->
    <el-dialog title="编辑手续费模板" :visible.sync="dialogVisible1" append-to-body width="35%">
      <div class="infobox clearfix">
        <div>
          <span>手续费模板名称:</span>
          <!-- <input type="text" v-model="obj.FeeTemplateName"  disabled> -->
          <el-select v-model="selecttpl" filterable clearable value-key="ExchangeNo" style="width:67%" placeholder="请选择" @change="changeCommodity">
            <el-option v-for="item in templatelist" :key="item.Code" :label="item.Name" :value="item.Code">
            </el-option>
          </el-select>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible1 = false">取 消</el-button>
        <el-button type="primary" @click="saveifno()">确 定</el-button>
      </span>
    </el-dialog>
  </el-table>
</template>

<script>
import EnumConfig from "../../../assets/js/EnumConfig.js";
export default {
  // 我的客户
  name: "tableCom",
  data() {
    return {
      dialogVisible: false,
      dialogVisible1: false,
      obj: {},
      templatelist: [],
      selecttplname: "",
      selecttpl: "",
      UserCode: "",
      AgentFeeTemplatesIsShow: true
    };
  },
  props: ["data"],
  filters: {
    GetSource(type) {
      return EnumConfig.GetSource(type);
    }
  },
   created() {
     if (sessionStorage.getItem("AgentFeeTemplatesIsShow") != null && sessionStorage.getItem("AgentFeeTemplatesIsShow") != "undefined") {
      this.AgentFeeTemplatesIsShow = JSON.parse(sessionStorage.getItem("AgentFeeTemplatesIsShow"));
    }
  },
  methods: {
    tableRowClassName({ row, rowIndex }) {
      if (rowIndex === 1) {
        return "warning-row";
      } else if (rowIndex === 3) {
        return "success-row";
      }
      return "";
    },
    // goUserInfo(obj) {
    //   let path = obj.UserCode.substring(0);
    //   sessionStorage.setItem("UserCode", obj.UserCode);
    //   this.$router.push("/selectedCominfo/selectedCominfo/" + path);
    // },
    // 查看客户详情
    handleClick(row) {
      this.dialogVisible = true;
      let url = "/mycustomer/GetInsUserDetail";
      this.$loginapi.post(url, row, response => {
        if (response.Ret == 0) {
          this.obj = response.Data;
        } else {
          this.$message.error(response.Msg);
        }
      });
    },
     // 编辑
    editClick(row) {
      this.UserCode = row.UserCode;
      this.selecttpl = row.FeeTemplateID;
      this.dialogVisible1 = true;
      let url = "/mycustomer/GetInsUserFeeTemplates";
      this.$loginapi.post(url, row, response => {
        if (response.Ret == 0) {
          this.templatelist = response.Data;
        } else {
          this.$message.error(response.Msg);
        }
      });
    },
    changeCommodity(item) {
      // this.selecttpl = item;
    },
    saveifno() {
      if (this.selecttpl == "") {
        this.$alert("请选择手续费模板");
        return;
      }
      let url = "/mycustomer/ModifyInsUserFeeTemplate";
      let postData = {
        UserCode: this.UserCode,
        FeeTemplateId: this.selecttpl
      };
      this.$loginapi.post(url, postData, response => {
        this.dialogVisible1 = false;
        this.templatelist = [];
        if (response.Ret == 0) {
          this.$message.success(response.Msg);
          this.$emit("getlist");
        } else {
          this.$message.error(response.Msg);
        }
      });
    },
    gomTemplateInfo(obj) {
      let path = obj.FeeTemplateID.substring(3);
      this.$store.state.tpInfo = obj;
      sessionStorage.setItem("TpCode", obj.FeeTemplateID);
      this.$router.push("/templatesinfo/subcommissiontemplatesinfo/" + path);
    }
  }
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/subaccounts/tableCom/tableCom.vue